<template>
    <div class="subIBReport">
        ====================》这是subIBReport页
    </div>
</template>
<script>
export default {
    name:'subIBReport',
      data() {
        return {
        
        }
    },
    mounted(){
        
    },
    methods: {
        
    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// subIBReport.vue?4d3087cd